import React from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core'
import AvatarEditor from 'react-avatar-edit'

interface AvatarUploadModal {
  image?: File
  open: boolean
  handleClose: () => void
  onCrop: (image: string) => void
  onSave: () => void
}

export const ProfileImageEditDialog = (props: AvatarUploadModal) => {
  const { image, open, handleClose, onCrop, onSave } = props

  const img = new Image()
  img.src = URL.createObjectURL(image)
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Edit / Crop your photo</DialogTitle>
      <DialogContent>
        <AvatarEditor
          img={img}
          imageWidth={400}
          imageHeight={300}
          width={400}
          height={300}
          closeIconColor="#ffffff00"
          onCrop={onCrop}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button onClick={onSave} color="primary" autoFocus>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  )
}
